@if (loading()) {
	<div class="spin-wrapper"><nz-spin nzSimple nzSize="large"></nz-spin></div>
} @else if (content(); as content) {
	<div [innerHTML]="content.active_text?.description_html"></div>
}
